
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {IAddShippingModel, ICustomerModel, IUserModel} from "@/api/types";
import {Message} from "element-ui";
import {defaultCustomerData, searchCustomer} from "@/api/customer";
import {FactoryLoadingPlan} from "@/model/FactoryLoadingPlan";
import ContainerTypeReleasedInfo from "@/views/components/ContainerTypeReleasedInfo.vue";
import {getShippingOrders} from "@/api/shipping-order";
import FactoryLoadingPlanHqPackingListInfoTable from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";
import TaxRefundDialog from "@/views/components/TaxRefundDialog.vue";
import {ShippingOrderModel} from "@/model/shipping-order";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import {BookingOrderProcessStage, DeclarationState} from "@/model/booking-order";
import {INTERNATIONAL_TRADE_TERMS, LADING_TYPE, PAYMENT_TYPE} from "@/constant";
import DeclarationDocumentTable, {LoadingPlanListTableRowData} from "@/views/components/DeclarationDocumentTable.vue";
import AuditTable from "@/views/components/AuditTable.vue";
import ExtraTable from "./components/ExtraTable.vue";
import {
  auditCreatePaymentOrder,
  auditDetail,
  createLoadingPlanList,
  editMoneyList,
  financeConfirmReceipt,
  getAuditTable,
  getLoadingPlanListDetail,
  getLoadingPlanLists,
  getMoneyList,
  getProductInfo,
  getTaxRefundInfo,
  listProcessStagesFinance,
  poFeeSettlement,
  previewCustomsDeclarationForAudit,
  queryDeclarationInfo,
  saveAuditTable, saveBookingOrderAuditUse,
  searchBookingOrderForSales,
  updateBookingOrder,
  updateCheckPrerecordListDate,
  updateDeadlineDate,
  updateDeclarationInfo,
  updateLoadingPlanList,
  updatePaymentOrder,
  updateSailingSchedule
} from "@/api/booking-order";
import ContainerLoadingInfoComponent, {
  ContainerLoadingInfoData,
  LoadingPlanInfo
} from "@/views/components/ContainerLoadingInfoComponent.vue";
import {CustomsPackingModel} from "@/model/HenganLoadingPlanModels";
import {ExtraMoneyList, ProductDetail, TaxRefundInfo} from "@/model/FinancialBookingModels";
import {getFinancialConfiguration} from "@/api/configuration";
import {deepClone} from "@/utils/deepClone";
import {add, divide, subtract} from "@/utils/number";
import VirtualList from 'vue-virtual-scroll-list'
import Item from "./components/Item.vue"
import ProductDetailDialog from "@/views/financial-management/components/ProductDetailDialog.vue";
import {timeParser} from "@/filters";
import PoFeeSettlement from "@/views/financial-management/components/PoFeeSettlement.vue";
import CustomsDeclarationPreviewDialog, {
  CustomsDeclarationPreviewItem,
} from "@/views/sales-management/components/CustomsDeclarationPreviewDialog.vue";
import {checkAccount} from "@/directives";
import Template from "@/views/system-management/template/index.vue";

@Component({
  name: "FinancialBookingOrderManagement",
  components: {
    Template,
    PoFeeSettlement,
    ProductDetailDialog,
    ContainerLoadingInfoComponent,
    DeclarationDocumentTable,
    AuditTable,
    ExtraTable,
    FactoryLoadingPlanHqPackingListInfoTable,
    ContainerTypeReleasedInfo,
    Pagination,
    TaxRefundDialog,
    VirtualList,
    CustomsDeclarationPreviewDialog
  },
  methods: {
    checkAccount,
    PAYMENT_TYPE,
    INTERNATIONAL_TRADE_TERMS,
    LADING_TYPE
  }
})
export default class extends Vue {
  public itemComponent = Item
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private addRemarkDialogVisible = false;
  private showFileList = false;
  private files: File[] = [];
  private textMap = {
    create: "新增报关合同",
    update: "编辑报关合同",
    addShippingOrder: "添加舱单",
    releaseContainerType: "分配柜型"
  };
  private JobPositionType = {
    seller: "seller",
    logisticsClerk: "logistics-clerk"
  };
  private sellerList: IUserModel[] = [];
  private logisticsClerkList: IUserModel[] = [];
  private shippingOrderList: IAddShippingModel[] = [];
  private payload = new FactoryLoadingPlan();
  private writeBookingOrderDialogVisible = false;
  private rules = {
    code: [{ required: true, message: "请输入报关合同号", trigger: "blur" }],
    customerId: [{ required: true, message: "请选择客户", trigger: "blur" }],
    shippingOrderId: [
      { required: true, message: "请选择订舱单", trigger: "blur" }
    ],
    currency: [{ required: true, message: "请选择结算货币", trigger: "blur" }]
  };
  private processStages: BookingOrderProcessStage[] = [];
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    code: null,
    startDate: null,
    endDate: null,
    customerKeyword: null,
    stage: null,
    receiptState: null,
    dateRange: null,
    processStage: null
  };
  private bookingOrders: BookingOrderTableRowData[] = [];
  private currentRow: BookingOrderTableRowData = new BookingOrderTableRowData();
  private currentExtra: ExtraMoneyList[] = [];
  private taxRefundInfo: TaxRefundInfo = new TaxRefundInfo();
  private productDetails: ProductDetail = new ProductDetail();

  private writeBookingOrderRequest: WriteBookingOrderRequest =
    new WriteBookingOrderRequest();
  private listRemark = {
    bookingOrderId: null,
    remark: null
  };

  created() {
    this.initProcessStages();
    this.getList();
    this.getFinancialConfiguration();
  }

  private showAddRemarkDialog(row) {
    this.listRemark = {
      bookingOrderId: row.id,
      remark: row.remark
    };
    this.addRemarkDialogVisible = true;
  }


  private async doAddRemark() {
    await updateBookingOrder(
        this.listRemark.bookingOrderId, {
          remark: this.listRemark.remark,
          type: "AUDIT_PAGE"
        }
    );
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

  private async initProcessStages() {
    const data: any = await listProcessStagesFinance();
    this.processStages = data;
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private isSearchingCustomers = false;
  private customers: ICustomerModel[] = [];

  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
      .then((res: any) => {
        this.customers = res;
        this.isSearchingCustomers = false;
      })
      .catch(() => {
        this.isSearchingCustomers = false;
      });
  }

  // 汇率/MER调整
  private updateFinancialConfigurationDialogVisible = false;
  private financialConfiguration: FinancialConfiguration =
    new FinancialConfiguration(null, null, null, null);

  private async getFinancialConfiguration() {
    const { exchangeRateUSD, merUSD, exchangeRateEURO, merEURO }: any = await getFinancialConfiguration();
    this.financialConfiguration = new FinancialConfiguration(exchangeRateUSD, merUSD, exchangeRateEURO, merEURO);
  }

  private isLoadingShippingOrders = false;
  private shippingOrders: ShippingOrderModel[] = [];

  private getCustomerShippingOrders() {
    if (!this.writeBookingOrderRequest.customerId) {
      Message.error({ message: "请先选择客户", duration: 2000 });
      return;
    }
    this.isLoadingShippingOrders = true;
    getShippingOrders(this.writeBookingOrderRequest.customerId).then(
      (res: any) => {
        this.shippingOrders = res;
        this.isLoadingShippingOrders = false;
      }
    );
  }

  private async handleEditDeadlineDate(row: BookingOrderTableRowData) {
    if (!row.newDeadlineDate) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateDeadlineDate(row.id, row.newDeadlineDate);
    row.isEditDeadlineDatePopoverVisible = false;
    row.newDeadlineDate = null;
    await this.getList();
  }

  private async handleEditSailingSchedule(row: BookingOrderTableRowData) {
    if (!row.newSailingSchedule) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await updateSailingSchedule(row.id, row.newSailingSchedule);
    row.isEditSailingSchedulePopoverVisible = false;
    row.newSailingSchedule = null;
    await this.getList();
  }

  // 预录单核对
  private async handleEditcheckPrerecordListDate(
    row: BookingOrderTableRowData
  ) {
    if (!row.sailingSchedule) {
      Message.error({ message: "请选择申报日期", duration: 2000 });
      return;
    }
    if (!row.newcheckPrerecordListDate) {
      Message.error({ message: "请选择预录单核对日期", duration: 2000 });
      return;
    }
    this.preRecordLoading = true;
    await updateCheckPrerecordListDate(row.id, row.newcheckPrerecordListDate, row.sailingSchedule);
    this.preRecordLoading = false;
    row.isEditcheckPrerecordPopoverVisible = false;
    row.newcheckPrerecordListDate = null;
    await this.getList();
  }

  private onCustomerSelectionChange() {
    this.writeBookingOrderRequest.shippingOrderId = null;
  }

  private async getList() {
    this.listLoading = true;
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    }else {
      this.listQuery.startDate = null;
      this.listQuery.endDate = null;
    }
    const params = { ...this.listQuery,type:'AUDIT_PAGE' };
    params.dateRange = null;
    const { content, total }: any = await searchBookingOrderForSales(params);
    this.bookingOrders = content.map((value) => {
      return {
        ...value,
        isEditDeadlineDatePopoverVisible: false,
        isEditSailingSchedulePopoverVisible: false,
        isEditcheckPrerecordPopoverVisible: false,
        newDeadlineDate: value.deadlineDate,
        newSailingSchedule: value.sailingSchedule,
        newcheckPrerecordListDate: value.checkPrerecordListDate
      };
    });
    this.total = total;
    this.listLoading = false;
  }

  private companyTypes: CompanyType[] = [];

  private checkPermission(value) {
    return this.$route.meta.buttonCodes.includes(value)
  }

  private initCompanyTypes() {
    this.companyTypes = [];
    this.companyTypes.push(new CompanyType("SELF", "自拉自报"));
    this.companyTypes.push(new CompanyType("APPOINTED", "指定货代"));
    this.companyTypes.push(new CompanyType("OTHER", "其他类型"));
  }

  // 确认报关信息
  private confirmDeclarationInfoDialogVisible = false;
  private declarationInfo: DeclarationInfo = new DeclarationInfo(
    defaultCustomerData,
    new DeclarationCharge()
  );

  private async showConfirmDeclarationInfoDialog(
    row: BookingOrderTableRowData
  ) {
    this.currentRow = row;
    this.confirmDeclarationInfoDialogVisible = true;
    const { customer, declarationCharge }: any = await queryDeclarationInfo(
      row.id
    );
    this.declarationInfo = new DeclarationInfo(
      customer,
      declarationCharge || new DeclarationCharge()
    );
  }

  // 验审
  private showAudit = false;
  private canEditAudit = true;
  private checkID = '';

  private async showAuditDialog(row: BookingOrderTableRowData, canEdit: boolean) {
    this.loadingPlans = [];
    this.loadingAudit = new LoadingAudit();
    this.loadingPlanFilter = new LoadingPlanFilter();
    this.currentRow = row;
    this.checkID = row.id;
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    if (canEdit === true) {
      await getAuditTable(row.id).then((data:any) => {
        this.loadingAudit = data;
        this.canEditAudit = canEdit;
        this.getTotalFCR();
        this.showAudit = true;
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      });
    }else {
      await auditDetail(row.id).then((data:any) => {
        this.loadingAudit = data;
        this.canEditAudit = canEdit;
        this.getTotalFCR();
        this.showAudit = true;
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      });
    }
  }

  //验审结算
  // private async calculateTotal(name: string,index,source) {
  //   const info = deepClone(this.loadingAudit);
  //   info.factoryInfos.map((item, index) => {
  //     item.purchaseOrderProductInfos = (
  //       (this.$refs.virtualList as any).$refs.auditTableTable[index] as Vue & { data_: [] }
  //     ).data_;
  //   });
  //   if (name !== "totalDeclarationAmount" || (name === "totalDeclarationAmount" && !this.loadingAudit.useInvoiceMoney)) {
  //     let total = 0;
  //     info.factoryInfos.forEach((element) => {
  //       let itemTotal = 0;
  //       element.purchaseOrderProductInfos.forEach((item) => {
  //         itemTotal = item[name] + itemTotal;
  //       });
  //       total = itemTotal + total;
  //     });
  //     this.loadingAudit[name] = Number(total.toFixed(4));
  //   }
  //   this.getTotalFCR();
  // }

  private async calculateTotal(name: string) {
    const info = deepClone(this.loadingAudit);
    if (name === "totalSettlementAmount") {
      let total = 0;
      info.factoryInfos.forEach((element) => {
        let itemTotal = 0;
        element.purchaseOrderProductInfos.forEach((item) => {
          itemTotal = item[name] + itemTotal;
        });
        total = itemTotal + total;
      });
      this.loadingAudit[name] = Number(total.toFixed(4));
    }
    this.getTotalFCR();
  }

  private totalFCR = 0;

  private getTotalFCR() {
    // 财税控制率=结算总金额/1.13/报关总金额
    let totalFCR = this.loadingAudit.totalSettlementAmount / 1.13 / this.loadingAudit.totalDeclarationAmount
    // totalFCR.toFixed(4);
    // if(this.loadingAudit.useInvoiceMoney) {
    //   // 使用IV金额,财税控制率=结算总金额/1.13/报关总金额*币种对USD汇率
    //   if("EURO" === this.loadingAudit.currencyUnit) {
    //     totalFCR = totalFCR
    //       * Number(this.financialConfiguration.exchangeRateUSD) / Number(this.financialConfiguration.exchangeRateEURO);
    //   }
    //   if("RMB" === this.loadingAudit.currencyUnit) {
    //     totalFCR = totalFCR
    //       * Number(this.financialConfiguration.exchangeRateUSD);
    //   }
    // }
    this.totalFCR = Number(totalFCR.toFixed(4));
  }

  // 保存验审
  private async handleSaveInvoiceMoney(confirm: boolean) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    const info = deepClone(this.loadingAudit);
    const factoryInfos = info.factoryInfos;
    let message;
    factoryInfos.forEach(item => {
      item.purchaseOrderProductInfos.forEach(product => {
        if (product.settlementUnit.includes("/")) {
          message = `【${item.factoryName}】的【${product.invoiceDescription}】的结算单位错误，不能选择带'/'的单位`;
          return;
        }
      })
    })
    if (message) {
      this.$message.error(message);
      loading.close();
      return;
    }
    // info.factoryInfos.forEach((element) => {
    //   element.purchaseOrderProductInfos.forEach((item) => {
    //     delete item.selectUnit;
    //   });
    // });
    info.factoryInfos.map((item) => {
      item.purchaseOrderProductInfos.forEach((val) => {
        if (val.deductionAndFilling && val.invoiceDescription) {
          item.settledProductDescription = val.invoiceDescription;
        }
      });
    });
    const data: any = {
      confirm,
      bookingOrderAuditId: info.id,
      saleName: info.saleName,
      currencyUnit: info.currencyUnit,
      totalUploadAmount: info.totalUploadAmount,
      totalSettlementAmount: info.totalSettlementAmount,
      totalDeclarationAmount: info.totalDeclarationAmount,
      fcr: this.totalFCR,
      factoryInfoList: info.factoryInfos
    };
    await saveAuditTable(this.loadingAudit.bookingOrderId, data).then(async () => {
      const useData = {
        bookingOrderId: this.loadingAudit.bookingOrderId,
        usePoFeeList: this.purchaseOrderFeeUseInfos,
      }
      await saveBookingOrderAuditUse(useData);

      if (confirm) {
        auditCreatePaymentOrder(this.loadingAudit.bookingOrderId);
      }
      this.showAudit = false;
      loading.close();
      await this.getList();
    }).catch(err => {
      console.log(err);
      loading.close();
    });
  }

  private generalPaymentVoucher(id) {
    this.$confirm('验审未成功生成付款单，是否重新生成?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      await auditCreatePaymentOrder(id).then(async () => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        await this.getList();
      }).finally(() => {
        loading.close();
      });
    });
  }

  private async handleExport() {
    const res: any = this.loadingAudit.factoryInfos;
    let list = await this.dealData(res);
    // const filename = `报关合同验审详情-${this.loadingAudit.bookingOrderCode}`;
    const filename = `${this.loadingAudit.bookingOrderCode}-报关合同验审详情`;
    const filterVal = [];
    const tableDatas = [];
    const t1 = ["报关合同验审导出"];

    let multiHeader = [
      ...list,
    ];

    const merges = [
      "A1:N1",
    ];

    let list_styles = await this.dealStyles(list);
    let styles = [...list_styles];

    //注意：组装的导出excel所需要的数据结构
    const excelDatas = [
      {
        header: t1,
        filterVal,
        tableDatas,
        merges,
        multiHeader,
        styles,
        sheetName: "Sheet1", // 表一的sheet名字
      },
    ];
    //   引入的函数
    this.json2excel(excelDatas, filename);
  }

  private async dealData(data: FactoryInfos[]) {
    let newData = deepClone(data);
    let arr = [];
    newData.map((item) => {

      // 20GP     箱号/封号
      // customsPackingInfo.title = `${item.name} ${item.containerNumber}/${item.sealNumber}`;
      // customsPackingInfo.customsPackingSet = item.customsPackingSet;
      // customsPackingInfo.items = [];
      const header1 = [
          "工厂名称",
          item.factoryName,
          "货源地",
          item.factoryAddress,
      ];
      const header2 = [
          "报关金额",
          item.totalDeclarationAmount,
          "FCR值",
          item.fcr,
      ];
      const header3 = [
        "开票品名",
        "订单号码",
        "数量调整",
        "结算单位",
        "上传品名单价",
        "结算单价",
        "其他费用结算",
        "采购订单费用",
        "补扣款",
        "额外费用备注",
        "付款单金额",
        "结算品名总金额",
        "报关品名总金额",
        "FCR",
      ];
      arr.push(header1);
      arr.push(header2);
      arr.push(header3);
      item.purchaseOrderProductInfos.map((val) => {
        const purchaseOrderFee = val.purchaseOrderFee == null ? 0 : val.purchaseOrderFee;
        const deductionAndFilling = val.deductionAndFilling == null ? 0 : val.deductionAndFilling;
        // 付款单金额=产品货款-补扣款+采购订单费用
        const paymentAmount = (val.returnSettlementAmount || 0) - deductionAndFilling + purchaseOrderFee;
        // 结算品名总金额=产品货款-其他费用-补扣款+采购订单费用
        const totalSettlementAmount = this.canEditAudit
          ? (val.returnSettlementAmount || 0) - (val.otherCharge || 0) - deductionAndFilling + purchaseOrderFee
          : val.totalSettlementAmount;
        const orderNumber = val.batch == null
          ? val.purchaseOrderNumber
          : `${val.purchaseOrderNumber}(${val.batch})`;
        const quantity = val.settlementUnit && val.settlementUnit.indexOf("千克") > -1
          ? val.productNetWeight
          : val.productNumberPcs;
        const settlementUnitPrice = this.canEditAudit
          ? divide(totalSettlementAmount, val.productNumberPcs, 4)
          : val.settlementUnitPrice;
        const fcr = Number(totalSettlementAmount / 1.13 / val.totalDeclarationAmount).toFixed(4);
        let data = [
            val.invoiceDescription,
            orderNumber,
            quantity,
            val.settlementUnit,
            val.unitPrice,
            settlementUnitPrice,
            val.otherCharge === undefined? "0" : val.otherCharge,
            purchaseOrderFee,
            deductionAndFilling,
            val.deductionAndFillingRemark == null ? "" : val.deductionAndFillingRemark,
            paymentAmount,
            totalSettlementAmount,
            val.totalDeclarationAmount,
            fcr,
        ]
        arr.push(data);
      });
    });
    let list = arr;
    // arr.forEach((arrItem) => {
    //   arrItem.items.map((item, index) => {
    //     item.unshift(index + 1);
    //   });
    //   list = [...list, [arrItem.title]];
    //   list = [...list, ...[...arrItem.items]];
    // });
    // list.push(
    //     [
    //       "",
    //       "TOTAL",
    //       "",
    //       "",
    //       "",
    //       "",
    //       "",
    //       allTotal1,
    //       "",
    //       allTotal2,
    //       "",
    //       allTotal3,
    //       allTotal4,
    //       allTotal5,
    //     ],
    //     [""],
    //     ["REMARKS"],
    //     ["1.TOTAL ORDER QUANTITY IS " + allTotal1 + "PCS AUTO PARTS ."],
    //     ["2.TOTAL ORDER PACKAGES ARE " + allTotal2 + unit]
    // );
    return list;
  }


  private async dealStyles(data: any) {
    const commonStyle = {
      font: {
        name: "Times New Roman",
        sz: 11,
        color: { rgb: "#333333" },
        bold: true,
        italic: false,
        underline: false,
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true, //自动换行
      },
    };
    const letter = [
      "A",
    ];
    let list = [];
    for (let y = 0; y < letter.length; y++) {
      for (let i = 0; i < 18 + data.length; i++) {
        list.push({
          key: `${letter[y]}${i + 1}`,
          value: commonStyle,
        });
      }
    }
    return list;
  }


  private json2excel(tableJson: any, filename: string) {
    //这个是引用插件
    import("@/utils/excel").then((excel) => {
      const header = [];
      const data = [];
      const sheetname = [];
      const merges = [];
      const styles = [];
      const multiHeader = [];
      for (let i in tableJson) {
        header.push(tableJson[i].header);
        data.push(formatJson(tableJson[i].filterVal, tableJson[i].tableDatas));
        sheetname.push(tableJson[i].sheetName);
        merges.push(tableJson[i].merges);
        multiHeader.push(tableJson[i].multiHeader);
        styles.push(tableJson[i].styles);
      }
      excel.exportJson3Excel(
          header,
          data,
          sheetname,
          filename,
          multiHeader,
          merges,
          false,
          styles
      );
    });
  }

  // 额外费用结算
  private showExtra = false;
  private currentExtraIndex = 0;

  private showUpdateFinancialConfigurationDialog() {
    this.$router.push({path: `/system-management/information/financial`});
  }

  public auditTableTableData:any;
  private async showExtraDialog(item: FactoryInfos, index: number,auditTableTableData) {
    this.auditTableTableData = auditTableTableData;
    const data: any = await getMoneyList(
      this.loadingAudit.bookingOrderId,
      item.factoryName
    ).then((data) => {
      return data;
    });
    data.forEach((data_item) => {
      let filling = data_item.moneyList.filter((item) => {
        return item.type === "FILLING";
      });
      let deduct = data_item.moneyList.filter((item) => {
        return item.type === "DEDUCT";
      });
      data_item.filling = filling.length ? filling[0] : null;
      data_item.deduct = deduct.length ? deduct[0] : null;
    });
    this.currentExtra = data;
    this.currentExtraIndex = index;
    this.showExtra = true;
  }

  private poFeeSettlementVisible = false;
  private poFeeSettlementData = [];
  //采购订单费用结算
  private async poFeeSettlement() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      const res = await poFeeSettlement({bookingOrderId: this.loadingAudit.bookingOrderId}) as any;
      res.forEach(item => {
        this.loadingAudit.factoryInfos.forEach(factoryInfo => {
          if (factoryInfo.factoryName === item.factoryName) {
            const filter = factoryInfo.purchaseOrderProductInfos.filter(i =>
                i.hqPackingListId === item.hqPackingListId
                && i.purchaseOrderNumber === item.purchaseOrderCode)
            if (filter.length > 0) {
              item.auditProducts = filter.map(i => ({ ...i, usage: i.purchaseOrderFeeUsage }));
              item.useAmount = filter.reduce((acc, cur) => acc + cur.purchaseOrderFee, 0);
            }
          }
        });
      })
      this.poFeeSettlementData = res.reduce((result, item) => {
        // item的useDetails处理
        item.useDetails.map(useDetail => {
          if (useDetail.canUseAmount > 0) {
            useDetail.maxAmount = useDetail.canUseAmount;
            useDetail.minAmount = 0;
          } else {
            useDetail.maxAmount = 0;
            useDetail.minAmount = useDetail.canUseAmount;
          }
          return useDetail;
        });
        if (this.purchaseOrderFeeUseInfos.length > 0) {
          const useInfo = this.purchaseOrderFeeUseInfos.filter(useInfo =>
              useInfo.hqPackingListId === item.hqPackingListId && useInfo.purchaseOrderId === item.purchaseOrderId);
          if (useInfo) {
            item.useDetails.forEach(useDetail => {
              const find = useInfo.find(useItem => useItem.distributeId === useDetail.id);
              if (find) {
                useDetail.thisUseAmount = find.useAmount;
              }
            })
          }
        }

        // 查找是否已存在该分类的分组
        const existingGroup = result.find(group => group.factoryName === item.factoryName);
        if (existingGroup) {
          // 如果已存在，将当前项添加到对应的 list 中
          existingGroup.list.push(item);
        } else {
          // 如果不存在，创建新的分组
          result.push({
            factoryName: item.factoryName,
            list: [item]
          });
        }
        return result;
      }, []);
      this.poFeeSettlementVisible = true;
    } catch (error) {
      console.log(error);
    } finally {
      loading.close();
    }
  }

  private purchaseOrderFeeUseInfos = [];
  private purchaseOrderFeeSettlement(factoryInfos, useInfos) {
    this.purchaseOrderFeeUseInfos = useInfos;
    this.loadingAudit.factoryInfos.forEach(factoryInfo => {
      const factoryNames = factoryInfos.map(item => item.factoryName);
      if (factoryNames.includes(factoryInfo.factoryName)) {
        factoryInfo.purchaseOrderProductInfos.forEach(productInfo => {
          const found = factoryInfos.find(item => item.factoryName === factoryInfo.factoryName);
          found.list.forEach(item => {
            item.auditProducts.forEach(auditProduct => {
              if (productInfo.invoiceDescription === auditProduct.invoiceDescription
                  && productInfo.purchaseOrderNumber === auditProduct.purchaseOrderNumber
                  && productInfo.batch === auditProduct.batch
                  && productInfo.productType === auditProduct.productType
                  && productInfo.selectUnit[0].invoiceUnit === auditProduct.selectUnit[0].invoiceUnit) {
                this.$set(productInfo, 'purchaseOrderFee', auditProduct.purchaseOrderFee);
                this.$set(productInfo, 'purchaseOrderFeeUsage', auditProduct.usage);
                auditProduct.totalSettlementAmount =
                    auditProduct.returnSettlementAmount - auditProduct.otherCharge -
                    auditProduct.deductionAndFilling + auditProduct.purchaseOrderFee;
                this.$set(productInfo, 'totalSettlementAmount', auditProduct.totalSettlementAmount);
              }
            })
          })
        });
      }
    });
    this.calculateTotal("totalSettlementAmount");
  }

  // 添加到结算
  private async addExtraMoney() {
    this.auditTableTableData.extraInfoClear();
    const selection = (
      this.$refs.extraTable as Vue & { selection: ExtraMoneyList[] }
    ).selection;
    const list = deepClone(selection);
    if (!list.length) {
      this.auditTableTableData.getExtraInfo({
        deductionAndFilling: null, deductionAndFillingRemark: null
      });
    }
    const deductRemark = list.map((item) => {
      return item.deduct.remark;
    });
    const fillingRemark = list.map((item) => {
      return item.filling.remark;
    });
    const id = list.map((item) => {
      return item.hqPackingListId;
    });
    let deductionAndFilling = 0;
    list.map((item) => {
      item.total = subtract(item.settlementDeduct, item.settlementFilling, 2);
      deductionAndFilling = add(item.total, deductionAndFilling, 2);
    });
    const deductionAndFillingRemark = `${deductRemark.toString()},${fillingRemark.toString()}`;
    this.auditTableTableData.getExtraInfo({
      deductionAndFillingRemark,
      deductionAndFilling
    });
    const description = this.auditTableTableData.getMaxDescription();
    const data: { hqPackingListId, settlementFilling, settlementDeduct }[] = list;
    await editMoneyList(this.currentRow.id, { description: description, settlementMoneyList: data });
    this.loadingAudit.factoryInfos[this.currentExtraIndex].hqPackingListIds = id;
    this.showExtra = false;
  }

  private choice = true;

  private getExtraData(): ExtraMoneyList[] {
    if (this.choice) {
      return this.currentExtra.filter(value => {
        if (value.choice) {
          return value;
        }
      });
    } else {
      return this.currentExtra;
    }
  }

  private getPurchaseOrderProductInfos() {
    if (this.showExtra) {
      return (this.auditTableTableData as any).data_;
    }
    return [];
  }

  private confirmExtra(list) {
    let total = 0;
    list.forEach(item => {
      total += Number(item.thisSettlement);
    });
    (this.auditTableTableData as any).changeDeductionAndFilling(total);
  }

  private foldOrUnfold() {
    this.choice = !this.choice;
  }

  private getHiddenButtonsUser() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      if (this.$route.meta.buttonCodes.includes("confirmAuditableManager")) {
        return true;
      }
      return this.totalFCR <= 7 && this.totalFCR >= 5 && this.canEditAudit;

    }
  }

  private async updatePaymentOrderFa(name) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await updatePaymentOrder(this.checkID,name).then(res => {
      loading.close();
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
    }).catch(err => {
      loading.close();
      console.log(err);
    })
  }

  private getHiddenButtonsDetails(row) {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("queryAuditDetails") && row.processStage && row.processStage.canQueryAuditInfo;
    }
  }

  private async updateData(data,index) {
    await this.$set(this.loadingAudit.factoryInfos[index],'purchaseOrderProductInfos', data);
  }

  // 查看退税资料
  private showTaxRefund = false;

  private async showTaxRefundDialog(row: BookingOrderTableRowData) {
    this.getTaxRefundDialog(row.id);
    this.showTaxRefund = true;
  }

  private async getTaxRefundDialog(id: string) {
    const data: any = await getTaxRefundInfo(id);
    this.taxRefundInfo = data;
  }

  private showProductDetail = false;
  private async productDetail(id: string) {
    const res: any = await getProductInfo(id);
    this.productDetails = res;
    this.showProductDetail = true;
  }

  private async handleConfirmDeclarationInfo(confirm: boolean) {
    const paymentType = this.declarationInfo.customer.payment;
    if (
      (paymentType === "CIF" || paymentType === "CRF") &&
      !this.declarationInfo.declarationCharge.freight
    ) {
      return Message.error({ message: "请填写运费" });
    }
    await updateDeclarationInfo(this.currentRow.id, {
      confirm,
      ...this.declarationInfo.customer,
      ...this.declarationInfo.declarationCharge
    });
    this.confirmDeclarationInfoDialogVisible = false;
    await this.getList();
  }

  // 添加报关单据
  private addLoadingPlanListDialogVisible = false;
  // 已选中的报关单据
  private loadingPlanList: LoadingPlanList = new LoadingPlanList();
  private loadingPlanFilter: LoadingPlanFilter = new LoadingPlanFilter();
  private loadingPlans: LoadingPlanListTableRowData[] = [];
  // 已选中的验审
  private loadingAudit: LoadingAudit = new LoadingAudit();
  private preRecordLoading = false;

  // 查看退税资料
  private async showAddDeclarationDocumentDialog(
    row: BookingOrderTableRowData
  ) {
    this.loadingPlans = [];
    this.loadingPlanList = new LoadingPlanList();
    this.loadingPlanFilter = new LoadingPlanFilter();
    this.currentRow = row;
    this.addLoadingPlanListDialogVisible = true;
    const data: any = await getLoadingPlanLists(row.id);
    this.loadingPlanList = data;
    const unusedLoadingPlans = this.loadingPlanList.unusedLoadingPlans.map(
      (value) => this.generateDeclarationDocumentTableRowData(value, false)
    );
    const usedLoadingPlans = this.loadingPlanList.loadingPlans.map((value) =>
      this.generateDeclarationDocumentTableRowData(value, true)
    );
    this.loadingPlans = unusedLoadingPlans.concat(usedLoadingPlans);
  }

  private generateDeclarationDocumentTableRowData(
    loadingPlan: LoadingPlan,
    selected: boolean
  ): LoadingPlanListTableRowData {
    const rowData: LoadingPlanListTableRowData =
      new LoadingPlanListTableRowData();
    rowData.id = loadingPlan.id;
    rowData.code = loadingPlan.code;
    rowData.createdDate = loadingPlan.createdAt;
    rowData.containerType = loadingPlan.containerTypeInfos.join(",");
    rowData.type = loadingPlan.loadingPlanType;
    rowData.category = loadingPlan.category;
    rowData.loadingPlace = loadingPlan.factoryNames;
    rowData.containerInfo = loadingPlan.containerTypeInfos.join(",");
    rowData.totalProductQuantity = loadingPlan.totalPCS;
    rowData.totalAmount = loadingPlan.totalAmount;
    rowData.totalVolume = loadingPlan.volumes;
    rowData.select = selected;
    return rowData;
  }

  private removeSelectedDeclarationDocument() {
    (
      this.$refs.selectedDeclarationDocumentTable as DeclarationDocumentTable
    ).selection.forEach((value) => (value.select = false));
  }

  private addSelectedDeclarationDocument() {
    const selection: LoadingPlanListTableRowData[] = (
      this.$refs.availableLoadingPlanList as DeclarationDocumentTable
    ).selection;
    selection.forEach((value) => (value.select = true));
  }

  private async handleAddLoadingPlanList(confirm: boolean) {
    const selectedLoadingPlans = this.loadingPlans
      .filter((value) => value.select)
      .map((value) => {
        return { id: value.id, loadingPlanType: value.type };
      });
    const data: any = {
      bookingOrderId: this.currentRow.id,
      confirm,
      loadingPlans: selectedLoadingPlans
    };
    if (this.loadingPlanList.id) {
      await updateLoadingPlanList(this.loadingPlanList.id, data);
    } else {
      await createLoadingPlanList(data);
    }
    this.addLoadingPlanListDialogVisible = false;
    await this.getList();
  }

  //查看报关单据详情
  private checkLoadingPlanListDetailDialogVisible = false;
  private loadingPlanListDetail: LoadingPlanListDetailResponse =
    new LoadingPlanListDetailResponse();
  private containerLoadingInfos: ContainerLoadingInfoData[] = [];

  private gotoDocumentFlow(data) {
    this.$router.push({ name: "DocumentFlow", params: { type: "BOOKING_ORDER", documentId: data.id } });
  }

  private checkLoadingPlanListDetail(row: BookingOrderTableRowData) {
    this.checkLoadingPlanListDetailDialogVisible = true;
    this.currentRow = row;
    this.queryLoadingPlanListDetail(this.currentRow.loadingPlanListId);
  }

  private async queryLoadingPlanListDetail(loadingPlanListId: string) {
    const data: any = await getLoadingPlanListDetail(loadingPlanListId);
    this.loadingPlanListDetail = data;
    this.containerLoadingInfos = data.loadingInfos.map((value) => {
      const containerLoadingInfo: ContainerLoadingInfoData = { ...value };
      containerLoadingInfo.type = value.loadingPlanType;
      containerLoadingInfo.loadingPlans = value.loadingPlans.map(
        (loadingPlan) => {
          const loadingPlanInfo = new LoadingPlanInfo();
          loadingPlanInfo.id = loadingPlan.id;
          loadingPlanInfo.type = loadingPlan.loadingPlanType;
          loadingPlanInfo.code = loadingPlan.loadingPlanCode;
          loadingPlanInfo.customsPackingInfos = loadingPlan.customsPackingSet;
          return loadingPlanInfo;
        }
      );
      return containerLoadingInfo;
    });
  }

  // 确认收款
  private async handleConfirmReceipt(row: BookingOrderTableRowData) {
    if (!row.financeReceiptDate) {
      Message.error({ message: "请选择日期", duration: 2000 });
      return;
    }
    await financeConfirmReceipt(row.id, row.financeReceiptDate);
    row.isConfirmReceiptPopoverVisible = false;
    await this.getList();
  }

  // 导出excel
  private exportExcel() {
    const data = this.bookingOrders.map((value: any) => {
      return {
        createTime: timeParser(value.createdAt),
        deadlineTime: timeParser(value.deadlineDate),
        sailingScheduleTime: timeParser(value.sailingSchedule),
        customerAbb: this.renderCusAbbr(value.customerAbbr, value),
        stageDesc: value.processStage && value.processStage.desc,
        checkPrerecordListTime: timeParser(value.checkPrerecordListDate),
        financeReceiptTime: value.financeReceiptDate && timeParser(value.financeReceiptDate),
        ...value
      };
    });
    const headers = [
      "报关合同号",
      "创建日期",
      "截单日期",
      "申报日期",
      "客户简称",
      "处理阶段",
      "报关总金额",
      "工厂结算总金额",
      "预录单核对",
      "收款状态",
      "FCR计算值",
      "备注"
    ];
    const fieldNames = [
      "code",
      "createTime",
      "deadlineTime",
      "sailingScheduleTime",
      "customerAbb",
      "stageDesc",
      "totalDeclarationAmount",
      "totalSettlementAmount",
      "checkPrerecordListTime",
      "financeReceiptTime",
      "fcrNumber",
      "remark"
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `报关合同（财务）-${new Date()}`
    );
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

  private previewVisible = false;
  private previewLoading = false;
  private previewItems: CustomsDeclarationPreviewItem[] = [];
  private async declarationPreview() {
    const info = deepClone(this.loadingAudit);
    const data: any = {
      factoryInfoList: info.factoryInfos
    };

    this.previewItems = [];
    this.previewVisible = true;
    this.previewLoading = true;
    try {
      this.previewItems = await previewCustomsDeclarationForAudit(this.currentRow.id, data) as any;
    } finally {
      this.previewLoading = false;
    }
  }
}

class FinancialConfiguration {
  exchangeRateUSD: string;
  merUSD: string;
  exchangeRateEURO: string;
  merEURO: string;

  constructor(exchangeRateUSD: string, merUSD: string, exchangeRateEURO: string, merEURO: string) {
    this.exchangeRateUSD = exchangeRateUSD;
    this.merUSD = merUSD;
    this.exchangeRateEURO = exchangeRateEURO;
    this.merEURO = merEURO;
  }
}

class BookingOrderTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  customerId: string;
  shippingOrderId: string;
  shippingOrderCode: string;
  currencyUnit: string;
  receiptDate: string;
  deadlineDate: string;
  sailingSchedule: string;
  invoiceId: string;
  invoiceCode: string;
  useInvoiceMoney: boolean;
  invoiceMoney: string;
  loadingPlanListId: string;
  declarationState: DeclarationState;
  processStage: BookingOrderProcessStage;
  forwardingCompanies: Company[];
  financeReceiptDate: string;
  fcrNumber: string;

  //for edit
  newDeadlineDate: string;
  newSailingSchedule: string;
  newcheckPrerecordListDate: string;
  isEditDeadlineDatePopoverVisible = false;
  isEditSailingSchedulePopoverVisible = false;
  isEditcheckPrerecordPopoverVisible = false;
  isConfirmReceiptPopoverVisible = false;
  remark: string;
}

class DeclarationInfo {
  customer: ICustomerModel;
  declarationCharge: DeclarationCharge;

  constructor(customer: ICustomerModel, declarationCharge: DeclarationCharge) {
    this.customer = customer;
    this.declarationCharge = declarationCharge;
  }
}

class DeclarationCharge {
  id: string;
  bookingOrderId: string;
  freight: string;
  insurance: string;
  extras: string;
}

class WriteBookingOrderRequest {
  id: string = null;
  code: string = null;
  customerId: string = null;
  shippingOrderId: string = null;
  currencyUnit: string = null;
  forwardingCompanies: Company[] = [];
}

class LoadingPlanList {
  id: string;
  bookingOrderId: string;
  bookingOrderCode: string;
  customerAbbr: string;
  customerCode: string;
  loadingPlans: LoadingPlan[];
  unusedLoadingPlans: LoadingPlan[];
}

class LoadingPlan {
  id: string;
  loadingPlanType: LoadingPlanType;
  code: string;
  createdAt: string;
  category: string;
  factoryNames: string;
  containerTypeInfos: string[];
  totalPCS: number;
  totalAmount: string;
  volumes: string;
  customerId: string;
  customsPackingSet?: CustomsPackingModel[];
}

// 报关合同验审
class LoadingAudit {
  id: string;
  bookingOrderCode: string;
  bookingOrderId: string;
  factoryInfos: FactoryInfos[];
  saleName: string;
  totalDeclarationAmount: number;
  totalSettlementAmount: number;
  totalUploadAmount: number;
  useInvoiceMoney: boolean;
  invoiceMoney: string;
  currencyUnit: string;
  fcr: number;
  customerAmount: number; // 客人结算金额
  difference: number; // 小数位差
  freightAmount: number; // 运费
  insuranceAmount: number; // 保费
  extrasAmount: number; // 杂费
  ivOtherAmount: number; // iv其他费用
}

// 工厂信息
class FactoryInfos {
  id: string;
  supplierId: string;
  factoryCode: string;
  factoryName: string;
  factoryAddress: string;
  purchaseOrderProductInfos: PurchaseOrderProductInfos[];
  hqPackingListIds: [];
  settledProductDescription: string;
  totalDeclarationAmount: number;
  fcr: number;
}

// 工厂产品信息
class PurchaseOrderProductInfos {
  id: string;
  invoiceDescription: string;
  purchaseOrderNumber: string;
  productNumberPcs: number;
  productNetWeight: number;
  returnSettlementAmount: number;
  settlementUnit: string;
  unitPrice: number;
  labelingCharge: number;
  claimCharge: number;
  otherCharge: number;
  settlementUnitPrice: number;
  totalSettlementAmount: number;
  totalDeclarationAmount: number;
  deductionAndFilling: number;
  deductionAndFillingRemark: string;
  batch: string;
  selectUnit: any[];
  productType: string;
  hqPackingListId: string;
  purchaseOrderFee: number;
  purchaseOrderFeeUsage: any[];
}

export class Company {
  name: string;
  type: CompanyType;
}

class CompanyType {
  name: string;
  desc: string;

  constructor(name: string, desc: string) {
    this.name = name;
    this.desc = desc;
  }
}

class LoadingPlanFilter {
  code: string;
  category: string;
  factoryName: string;
}

class LoadingPlanListDetailResponse {
  id: string;
  bookingOrderCode: string;
  customerAbbr: string;
  shippingOrderCode: string;
  billLadingCode: string;
  forwardingCompanies: Company[];
  loadingInfos: LoadingPlan[];
}

export class LoadingPlanType {
  name: string;
  desc: string;
}
